import appSlice from "../AppSlice";
import infoPageSlice from "../components/InfoPage/InfoPageSlice";
import imageCaptureSlice from "../components/ImageCapture/ImageCaptureSlice";
import languageSelectSlice from "../components/LanguageSelect/LanguageSelectSlice";
import registrationPageSlice from "../components/RegistrationPage/RegistrationPageSlice";
import { configureStore } from "@reduxjs/toolkit";
import type { Action, ThunkAction } from "@reduxjs/toolkit";
import contactInfoSlice from "../components/CompletionPage/ContactInfoSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    registrationPage: registrationPageSlice,
    languageSelect: languageSelectSlice,
    infoPage: infoPageSlice,
    imageCapture: imageCaptureSlice,
    contactInfo: contactInfoSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
